const TRACK_DECHETS_API = `${__configuration.apiUrl}/massia/track-dechets`;
export default class RegistresService {
	constructor($http) {
		this.$http = $http;
		this.apiResult = null;
	}

	async getClients() {
		const siteUrl = `${__configuration.apiUrl}/massia/sites-clients/headers`;
		const res = await this.$http.get(siteUrl);
		return res.data;
	}

	async getSocietes() {
		const url = `${__configuration.apiUrl}/massia/societes-commerciales/header`;
		const res = await this.$http.get(url);
		return res.data;
	}

	async getSitesBySocieteId(idSociete) {
		const url = `${__configuration.apiUrl}/massia/sites-commerciaux/header/${idSociete}`;
		const res = await this.$http.get(url);
		return res.data;
	}

	async getAllEcoOrganismes() {
		const res = await this.$http.get(`${__configuration.apiUrl}/massia/eco-organisme-inertes`);
		if (res.data.length > 0) {
			return res.data
				.map((eo) => ({
					id: eo.societe.id,
					libelle: eo.societe.libelle,
					code: eo.societe.code
				})) // on distinct sur l'id
				.filter((eo, index, array) => array.findIndex((item) => item.id === eo.id) === index);
		}
	}

	async getTexsEntrants(idSociete, dateDebut, dateFin, idSiteCom = null, idNomenclatures = null) {
		const res = await this.$http.get(`${TRACK_DECHETS_API}/texs/entrants`, {
			params: {
				idSociete: JSON.stringify(idSociete),
				dateDebut: JSON.stringify(dateDebut),
				dateFin: JSON.stringify(dateFin),
				idSiteCom: JSON.stringify(idSiteCom || 0),
				idNomenclatures: JSON.stringify(idNomenclatures || [])
			}
		});
		console.log(res);

		if (res && res.data && res.data.content && res.data.content.length > 0) {
			return res;
		} else {
			return false;
		}
	}

	async printTexsEntrants(idSociete, dateDebut, dateFin, idSiteCom = null, idNomenclatures = null) {
		const res = await this.$http.post(`${TRACK_DECHETS_API}/texs/entrants/print`, undefined, {
			params: {
				idSociete: idSociete,
				dateDebut: dateDebut,
				dateFin: dateFin,
				idSiteCom: idSiteCom,
				idNomenclatures: idNomenclatures
			},
			responseType: 'arraybuffer'
		});

		return res;
	}

	async printTexsSortants(idSociete, dateDebut, dateFin, idSiteCom = null, idNomenclatures = null) {
		const res = await this.$http.post(`${TRACK_DECHETS_API}/texs/sortants/print`, undefined, {
			params: {
				idSociete: idSociete,
				dateDebut: dateDebut,
				dateFin: dateFin,
				idSiteCom: idSiteCom,
				idNomenclatures: idNomenclatures
			},
			responseType: 'arraybuffer'
		});

		return res;
	}

	async verifyDapGeoLoc(idSociete, dateDebut, dateFin, idSiteCom = null, idNomenclatures = null, doApply = false) {
		const res = await this.$http.get(`${TRACK_DECHETS_API}/texs/verification-dap-geo`, {
			params: {
				idSociete: JSON.stringify(idSociete),
				dateDebut: JSON.stringify(dateDebut),
				dateFin: JSON.stringify(dateFin),
				idSiteCom: JSON.stringify(idSiteCom || 0),
				idNomenclatures: JSON.stringify(idNomenclatures || []),
				doApply: JSON.stringify(doApply)
			}
		});

		return res;
	}

	async getTexsSortants(idSociete, dateDebut, dateFin, idSiteCom = null, idNomenclatures = null) {
		const res = await this.$http.get(`${TRACK_DECHETS_API}/texs/sortants`, {
			params: {
				idSociete: JSON.stringify(idSociete),
				dateDebut: JSON.stringify(dateDebut),
				dateFin: JSON.stringify(dateFin),
				idSiteCom: JSON.stringify(idSiteCom || 0),
				idNomenclatures: JSON.stringify(idNomenclatures || [])
			}
		});
		console.log(res);

		if (res && res.data && res.data.content && res.data.content.length > 0) {
			return res;
		} else {
			return false;
		}
	}

	async getNomenclatures() {
		const res = await this.$http.get(`${TRACK_DECHETS_API}/nomenclatures`, {});
		return res;
	}

	async getNomenclaturesAutorisee() {
		const res = await this.$http.get(`${TRACK_DECHETS_API}/nomenclatures-allowed`, {});
		return res;
	}
}
RegistresService.$inject = ['$http'];
